import React, {useState} from 'react';
import {bool, object, func} from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableRowMenu.module.css';

const ContactsTableRowMenu = ({
    contact,
    companyInfo,
    hidden,
    onToggleDeleteContactModal,
    onToggleEditContactModal,
    setContact
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setContact(contact);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleEditContact() {
        onToggleEditContactModal(true);
        handleClose();
    }

    function handleDeleteContact() {
        onToggleDeleteContactModal(true);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleEditContact}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Edit Contact
                </MenuItem>
                <MenuItem onClick={handleDeleteContact}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete Contact
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

ContactsTableRowMenu.defaultProps = {
    hidden:                     false,
    onToggleDeleteContactModal: () => {},
    onToggleEditContactModal:   () => {}
};

ContactsTableRowMenu.propTypes = {
    contact:                    object,
    companyInfo:                object,
    hidden:                     bool,
    onToggleDeleteContactModal: func,
    onToggleEditContactModal:   func,
    setContact:                 func
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default withRouter(
    connect(null, mapDispatchToProps)(ContactsTableRowMenu)
);
